module.exports = __webpack_public_path__ + "static/media/details-icon.386d6e88.svg";